interface BrandProps {
	collapsed?: boolean;
}

export function Brand({ collapsed = false }: BrandProps) {
	return (
		<div className="flex h-14 items-center gap-2.5 px-4">
			<span className="flex size-7 shrink-0 items-center justify-center rounded-lg bg-[var(--c-accent)] text-[13px] font-semibold text-white">
				M
			</span>
			{collapsed ? null : (
				<div className="min-w-0">
					<div className="truncate text-[13px] font-semibold leading-tight text-[var(--c-text)]">
						Murojaat
					</div>
					<div className="truncate text-[11px] leading-tight text-[var(--c-text-muted)]">
						Yordam boshqaruvi
					</div>
				</div>
			)}
		</div>
	);
}
